import axios from 'axios'
import { env } from 'src/utils/env'

export const getInfoPageDetail = async (slug: string) => {
  return await axios.get(`${env.BASE_MAGNOLIA_REST_URL}/delivery/info-page/${slug}`)
}
